import Marquee from 'react-fast-marquee';

const WORDS = [
  'Conviction',
  'Long terme',
  'Fondateurs',
  'Infrastructure',
  'Intelligence artificielle',
  'Climat',
  'Fintech',
  'Capital patient',
];

export const Ribbon = () => (
  <section className="border-y border-border py-10 md:py-14 overflow-hidden bg-[#0c0e12]">
    <Marquee speed={38} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic text-4xl md:text-5xl text-foreground/90 px-16">
            {w}
          </span>
          <span className="text-primary text-2xl">✳</span>
        </span>
      ))}
    </Marquee>
  </section>
);
